import React from 'react';

import styles from './LoaderElementSticky.module.css';

const LoaderElementSticky = () => {
  return (
    <>
      <div className={styles.loader_fon}></div>
      <div className={styles.loader_wrapper}>
        <div className={styles.loader}></div>
      </div>
    </>
  );
};

export default LoaderElementSticky;
